import Drupal from "features/translation/utils/Drupal"
import PropTypes from "prop-types";

function Trans({ text, variables }) {
  return (
    <>
      { Drupal.t(text, variables) }
    </>
  );
}

Trans.propTypes = {
  text: PropTypes.string.isRequired,
  variables: PropTypes.array,
}

export default Trans;
